import styled from "styled-components";

export const StyledSessionDetailsDrawerBookingDetailsWrapper = styled.div`
  border: 1.6px solid #1c1726;
  padding: 1.6rem;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  border-radius: 8px;
  background-color: #eae6f3;
`;
export const StyledSessionDetailsDrawerBookingDetailsItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  font-size: 1.4rem;
  color: #1c1726;

  .item-value {
    font-weight: 600;
    max-width: 30rem;
    width: 100%;
    text-align: left;
    overflow-wrap: anywhere;
  }
  @media (min-width: 390px) {
    flex-direction: row;
    justify-content: space-between;
    .item-title {
      width: 100%;
    }
    .item-value {
      text-align: right;
    }
  }
`;
